import { createModel } from '@rematch/core';

import { RootModel } from '@/store';

import { initialState } from './constants';
import { reportEffects } from './effects';
import { reportReducer } from './reducer';

export const reportModel = createModel<RootModel>()({
  state: initialState,
  reducers: reportReducer,
  effects: reportEffects,
});
